<template>
  <div
    v-loading="productivityLoading"
    class="card-base card-shadow--medium mb-10 widget small-widget"
  >
    <div class="flex justify-center align-center p-15" id="titleTable">
      <div
        class="widget-icon-box animated fadeInRight align-left"
        style="text-align: center"
      >
        <!-- IMAGE -->
        <el-avatar
          v-if="chosenUser !== ''"
          size="large"
          :src="Image"
          fit="scale-down"
        ></el-avatar>
        <img v-else class="image-logo" :src="Image" alt="logo" />

        <!-- ARROW ICON & AND COMPLETED TASKS / TOTAL TASKS -->
        <div class="badge-box">
          <span class="badge">
            <!-- ICON -->
            <i
              :class="`mdi mdi-trending-${IconCuality} ${IconColorCuality}`"
            ></i>

            <el-tooltip
              class="item"
              effect="dark"
              :content="TooltipText"
              placement="bottom"
            >
              <strong class="accenCompletedTaskst-text ml-2">
                {{ CompletedTasks }}/{{ TotalTask }}
              </strong>
            </el-tooltip>

            <!-- CARD 1 y CARD 2 -->
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="`${CompletedTasks} tareas completadas de ${TotalTask}`"
              placement="bottom"
            >
              <strong
                class="accent-text ml-2"
                v-if="TypeProductivityCard != 'ProductivityQuality'"
              >
                {{ CompletedTasks }}/{{ TotalTask }}
              </strong>
            </el-tooltip> -->

            <!-- CARD 3 -->
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="`Total de Solicitudes Completadas`"
              placement="bottom"
            >
              <strong
                class="accent-text ml-2"
                v-if="TypeProductivityCard == 'ProductivityQuality'"
              >
                {{ CompletedTasks }}/{{ TotalTask }}
              </strong>
            </el-tooltip> -->
          </span>
        </div>
      </div>

      <div class="widget-info box grow animated fadeInLeft ml-10">
        <!-- CARD TITLE-->
        <div style="text-align: right">
          <el-tooltip :content="Title" placement="top">
            <p>{{ Title }}</p>
            <!--
            <table id="titleTable">
              <tr>
                <td>{{ Title }}</td>
              </tr>
            </table>
            -->
          </el-tooltip>
        </div>
        <!-- PERCENT -->
        <h2
          class="m-0 text-truncate danger-text mr-10"
          style="cursor: pointer; text-align: end"
        >
          <!-- <a
            v-if="TypeProductivityCard != 'ProductivityQuality'"
            href="#"
            :class="{
              Rojo: rojopercent,
              Naranja: naranjapercent,
              Verde: verdepercent
            }"
            @click="getRequest"
          >
            {{ Percent }}
          </a> -->
          <!-- CARD 1 AND 2 -->
          <a
            v-if="TypeProductivityCard == 'ProductivityThisMonth'"
            href="#"
            :class="{
              Rojo: rojopercent,
              Naranja: naranjapercent,
              Verde: verdepercent
            }"
            @click="getRequest"
          >
            {{ Percent }}
          </a>

          <a
            v-if="TypeProductivityCard == 'ProductivityAccumulated'"
            href="#"
            :class="{
              Rojo: rojopercent,
              Naranja: naranjapercent,
              Verde: verdepercent
            }"
            @click="getRequest"
          >
            {{ KPI }}%
          </a>

          <!-- CARD 3 -->
          <a
            v-if="TypeProductivityCard == 'ProductivityQuality'"
            href="#"
            :class="{
              Rojo: rojopercent,
              Naranja: naranjapercent,
              Verde: verdepercent
            }"
            @click="getRequest"
          >
            {{ Percent }}
          </a>

          <a
            v-if="TypeProductivityCard == 'ProductivityQualityDepart'"
            href="#"
            :class="{
              Rojo: rojopercent,
              Naranja: naranjapercent,
              Verde: verdepercent
            }"
            @click="getRequest"
          >
            {{ Percent }}
          </a>
        </h2>
      </div>
    </div>
    <!-- CARD 1 AND 2 DRAWER -->
    <rabbey-base-drawer
      :title="task_label"
      :drawer.sync="drawerTask"
      :before-close="this.ClearAndCloseDrawer"
      size="75%"
    >
      <el-row>
        <el-col :span="6">
          <h2>
            Total de tareas en el mes: <strong> {{ totalTasks }} </strong>
          </h2>
        </el-col>
        <el-col :span="6">
          <h2>
            Tareas a cerrar a la fecha: <strong> {{ closeThisDay }} </strong>
          </h2>
        </el-col>
        <el-col :span="6">
          <h2>
            Tareas cerradas a tiempo: <strong> {{ closedInTime }} </strong>
          </h2>
        </el-col>
        <el-col :span="6">
          <h2>
            Tareas cerradas Tarde: <strong> {{ closedLate }} </strong>
          </h2>
        </el-col>
        <el-row>
          <el-col :span="6">
            <h2>
              Tareas Pendientes por cerrar: <strong> {{ openLate }} </strong>
            </h2>
          </el-col>
          <el-col :span="6">
            <h2>
              Tareas abiertas a tiempo: <strong> {{ openInTime }} </strong>
            </h2>
          </el-col>
          <el-col :span="6">
            <h2>
              KPI: <strong> {{ KPI }} % </strong>
            </h2>
          </el-col>
        </el-row>
      </el-row>
      <TaskTable :items="tasks" v-loading="loading"></TaskTable>
    </rabbey-base-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TaskTable from "@/views/apps/cmi/tasks/CommonTaks.vue";

export default {
  name: "ProductivityStatsCard",
  components: {
    TaskTable
  },
  props: {
    Title: {
      type: String,
      default: ""
    },
    completed: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    CompletedTasks: {
      type: Number,
      default: 0
    },
    IconCuality: {
      type: String,
      default: "down"
    },
    IconColorCuality: {
      type: String,
      default: "danger-text"
    },
    Percent: {
      type: String,
      default: "0%"
    },
    TotalTask: {
      type: Number,
      default: 0
    },
    TypeProductivityCard: {
      type: String,
      required: true
    },
    TooltipText: {
      type: String,
      required: true
    },
    Option: {
      type: Number
    }
  },

  data() {
    return {
      drawerTask: false,
      task_label: "",
      rojopercent: false,
      naranjapercent: false,
      verdepercent: false,
      percentKPI: 1
      // closedInTime: 0
    };
  },
  // created(){
  //    console.log(this.Title, this.Title.slice(0, 20)+'\n'+this.Title.slice(20))
  //     // console.log( this.Title.slice(20))
  //     //this.Title = this.Title.slice(0, 24)+'\n'+this.Title.slice(24)
  // },
  /*
  updated() {
    console.log("updated")
    //this.Percent = "";
  },
  */
  mounted() {
    //this.funcionPrueba("ProductivityAccumulated");
    this.getRequest2();
  },
  methods: {
    getRequest2() {
      let params = {
        timeout: 3 * 60 * 1000,
        EmployeeId: this.currentUser.EmployeeId,
        CompanySelected: this.currentUser.CompanySelected
      };

      const date = new Date();
      if (this.$store.state.productivity.chosenUser >= 0) {
        params.EmployeeId = this.$store.state.productivity.chosenUser;
      }

      switch (this.TypeProductivityCard) {
        case "ProductivityAccumulated":
          this.$store.dispatch("productivity/GetTaksAll", params);
          //this.KPI
          break;

        case "ProductivityThisMonth":
          params.Month = date.getMonth();
          this.$store.dispatch("productivity/GetTaks", params);
          //console.log("waos", this.KPI)
          break;
      }
    },
    getRequest() {
      // Using the prop TypeProductivityCard to condition the execution of the corresponding action and drawer.
      let params = {
        timeout: 3 * 60 * 1000,
        EmployeeId: this.currentUser.EmployeeId,
        CompanySelected: this.currentUser.CompanySelected,
        Option: this.Option
      };

      if (this.$store.state.productivity.chosenUser >= 0) {
        params.EmployeeId = this.$store.state.productivity.chosenUser;
      }

      const date = new Date();
      switch (this.TypeProductivityCard) {
        case "ProductivityThisMonth":
          this.task_label = "Productividad del Mes";
          params.Month = date.getMonth();
          this.$store.dispatch("productivity/GetTaks", params);
          this.drawerTask = true;
          //console.log("waos", this.KPI)
          break;

        case "ProductivityAccumulated":
          this.task_label = "Productividad Acumulada";
          this.$store.dispatch("productivity/GetTaksAll", params);
          this.drawerTask = true;
          //this.KPI
          break;

        case "ProductivityQuality":
          this.task_label = "Efectividad del Servicio";
          this.$store.dispatch("productivity/GetInteralRequest", params);
          this.$emit("openDrawer");
          break;

        case "ProductivityQualityDepart":
          this.task_label = "Efectividad del Servicio por Departamento";
          this.$store.dispatch(
            "productivity/GetInternalRequestsDeparment",
            params
          );
          this.$emit("openDrawer");
          break;

        default:
          break;
      }
    },
    ClearAndCloseDrawer(done) {
      //this.$store.dispatch("productivity/CleanTasks", null, { root: true });
      done();
    }
  },
  computed: {
    Image() {
      if (this.chosenUser !== "") {
        return this.chosenUserImage;
      }

      return require(`@/assets/images/logos-min/${this.currentCompany}.svg`);
    },
    User() {
      if (!this.$store.state.productivity.chosenUserName) {
        return this.USerName;
      }
      // Returns the name of the user chosen by the "super user"
      return this.$store.state.productivity.chosenUserName;
    },
    ...mapState({
      productivity: (state) => state.productivity.model,
      tasks: (state) => {
        let productivityTasks = state.productivity.tasks;
        //this.closedInTime = productivityTasks.filter(task => task.Status === "Cerrada a Tiempo" ).length
        //console.log("productivity data: ", productivityTasks);
        return productivityTasks;
      },
      totalTasks: (state) => state.productivity.totalTasks,
      loading: (state) => state.productivity.isLoading,
      productivityLoading: (state) => state.productivity.productivityLoading,
      chosenUser: (state) => state.productivity.chosenUser,
      chosenUserImage: (state) => state.productivity.chosenUserImage
    }),
    closedInTime() {
      let tasks = this.$store.state.productivity.tasks.filter(
        (task) => task.Status === "Cerrada a Tiempo"
      ).length;
      return tasks;
    },
    closedLate() {
      let tasks = this.$store.state.productivity.tasks.filter(
        (task) => task.Status === "Cerrada Retrasada"
      ).length;
      return tasks;
    },
    openInTime() {
      let tasks = this.$store.state.productivity.tasks.filter(
        (task) => task.Status === "Abierta a Tiempo"
      ).length;
      return tasks;
    },
    openLate() {
      let tasks = this.$store.state.productivity.tasks.filter(
        (task) => task.Status === "Abierta Retrasada"
      ).length;
      return tasks;
    },
    closeThisDay() {
      let fechaActual = new Date();
      let tasks = this.$store.state.productivity.tasks.filter(
        (task) =>
          new Date(task.LimitDate).getDate() <= fechaActual.getDate() &&
          new Date(task.LimitDate).getMonth() <= fechaActual.getMonth()
      ).length;
      return tasks;
    },
    pendingToClose() {
      let tasks = this.$store.state.productivity.tasks.filter(
        (task) => task.Status === "Abierta a Tiempo"
      ).length;
      return tasks;
    },
    KPI() {
      if (this.closedInTime == 0 || this.closeThisDay == 0) {
        return 0;
      }

      let kpi = (this.closedInTime / this.closeThisDay) * 100;
      //kpi > 100 ? 100 : kpi;
      if (kpi > 100) {
        return 100;
      }
      return kpi.toFixed(0);
    }
  },
  watch: {
    Percent: function (percent) {
      //console.log("porcentajes: ",percent.replace('%', ''), typeof percent.replace('%', ''))
      //console.log("porcentajes: ",Number(percent.replace('%', '')), typeof  Number(percent.replace('%', '')))
      //console.log("title: ", this.Title);
      //console.log("title: ", "string de prueba \n otra linea");
      // console.log(this.Title, this.Title.slice(0, 20))
      // console.log(this.Title, this.Title.slice(20))
      //console.log("porcentajes: ",Number(percent.replace('%', '')), typeof  Number(percent.replace('%', '')));
      percent = Number(percent.replace("%", ""));
      //this.percentKPI = this.KPI
      if (percent == "0" || (percent >= 0 && percent < 80)) {
        //this.percentKPI = this.KPI
        //console.log("rojo")
        this.rojopercent = true;
        this.naranjapercent = false;
        this.verdepercent = false;
        this.getRequest2();
        //console.log("rojo", this.rojopercent)
      }
      if (percent >= 80 && percent < 90) {
        //console.log("amarillo")
        this.naranjapercent = true;
        this.rojopercent = false;
        this.verdepercent = false;
        this.getRequest2();
        // console.log("naranja", this.naranjapercent)
      }
      if (percent >= 90) {
        //console.log("verde")
        this.verdepercent = true;
        this.rojopercent = false;
        this.naranjapercent = false;
        this.getRequest2();
        //console.log("verde", this.verdepercent)
      }
    }
    /*
    totalTasks: task => {
      //console.log("totalTasks: ",task)
    }
    */
    // Title: function(title) {
    //    //console.log(title, title.slice(0, 20))
    //    //console.log(title, title.slice(20))
    // }
  }
  /*Percep(){
    this.Percent = this.KPI;
  }*/
};
</script>

<style scoped>
.item {
  margin-top: 10px;
  margin-right: 0;
  padding: 8px;
}

.image-logo {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.3));
}

.Verde {
  color: green;
}
.Naranja {
  color: orange;
}
.Rojo {
  color: rgba(255, 0, 0, 0.712);
}
#titleTable {
  height: 100px;
}
</style>
